/* eslint-disable */
export default {
  _odin_roundedregular: 'odin_roundedregular',
}